import React, {useContext, useEffect} from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import InputCheckbox from "../../form/input/InputCheckbox";
import ArrowIcon from "../../icons/DownArrowIcon";
import AccessIcon from "../../icons/AccessIcon";
import StoreController from "../../../stories/_client/Stores/StoreController";
import ContractController from "../../../stories/_client/Contract/ContractController";
import StringTools from "../../../class/tool/StringTools";
import DevelopmentRequestController from "../../../stories/_ticket/DevelopmentRequests/DevelopmentRequestController";
import AppContext from "../../../context/AppContext";

const Line = props => {
    const { object, item, model, checkable, openable, preview, checked, handleChecked, handleMenu } = props;
	const { setBubbleText } = useContext(AppContext);
    let localChecked = checked;

    const handleClickOnCheckbox = (event) => {
        localChecked = !localChecked;
        createRipple(event);
        handleChecked(object.id);
    }
    const colorLine = () => {
        if (localChecked)
            $("#line-" + object.id).addClass("checked");
        else
            $("#line-" + object.id).removeClass("checked");
    }
    const getOffset = elmt => {
        const rect = elmt.getBoundingClientRect()

        return {
            left: rect.left + $(".main").scrollLeft(),
            top: rect.top + $(".main").scrollTop()
        };
    }
    const createRipple = (event) => {
        const line = document.getElementById("line-" + object.id);
        const containerCircle = document.createElement("div");
        const circle = document.createElement("span");
        const diameter = Math.max(line.clientWidth, line.clientHeight);
        const radius = diameter / 2;
        const offset = getOffset(line);

        containerCircle.classList.add("containerCircle");
        containerCircle.style.width = `${line.clientWidth}px`;
        containerCircle.style.height = `${line.clientHeight}px`;
        containerCircle.style.left = `${offset.left - $(".menu").width()}px`;
        containerCircle.style.top = `${offset.top - $(".headerStore").height()}px`;
        circle.style.width = circle.style.height = `${diameter}px`;
        circle.style.left = `${event.clientX - radius}px`;
        circle.style.top = `${line.clientHeight / 2 - radius}px`;
        circle.classList.add("ripple");

        if (localChecked)
            circle.classList.add("blue");
        else
            circle.classList.add("gray");

        const ripple = line.getElementsByClassName("containerCircle")[0];

        if (ripple)
            ripple.remove();

        containerCircle.appendChild(circle);
        line.appendChild(containerCircle);

        setTimeout(() => {
            colorLine();
        }, 300);
        setTimeout(() => {
            containerCircle.remove();
            colorLine();
        }, 600);
    }
    const displaySince = strDate => {
        return moment(strDate).fromNow(true);
    }
    const displayDate = strDate => {
        return strDate !== null ? moment(strDate).format("DD MMM YYYY") : "-";
    }
    const displayDateTime = strDate => {
        return strDate !== null ? moment(strDate).format("DD MMM YYYY, LT") : "-";
    }
    const buildForType = (attributes, type) => {
        switch (type) {
            case "date":
                return displayDate(object[attributes[0]])
            case "datetime":
                return displayDateTime(object[attributes[0]])
            case "price":
                if (item === "products") {
                    return <Link to={ "/products/" + object.id + "/pricelists" }>
                        <span>
                            <NumericFormat value={ object[attributes[0]] } decimalScale={2} decimalSeparator={','} fixedDecimalScale={true} displayType={'text'} />
                            { object[attributes[0]] !== null ? " €" : "" }
                        </span>
                    </Link>
				}
				else if (item === "contracts") {
					if (object.discountValue !== null) {
						return <div onMouseOver={() => { mouseOverContractAmount(true) }} onMouseOut={() => { mouseOverContractAmount(false) }}>
							<span className={"withDiscount"}>
								<NumericFormat value={ object.amountExclTaxUndiscounted } decimalScale={2} decimalSeparator={','} fixedDecimalScale={true} displayType={'text'} />
								{ object[attributes[0]] !== null ? " €" : "" }
							</span><br />
							<span>
								<NumericFormat value={ object[attributes[0]] } decimalScale={2} decimalSeparator={','} fixedDecimalScale={true} displayType={'text'} />
								{ object[attributes[0]] !== null ? " €" : "" }
							</span>
						</div>
					}
					else {
						return <span>
							<NumericFormat value={ object[attributes[0]] } decimalScale={2} decimalSeparator={','} fixedDecimalScale={true} displayType={'text'} />
							{ object[attributes[0]] !== null ? " €" : "" }
						</span>
					}
				}
                else
                    return <span><NumericFormat value={ object[attributes[0]] } decimalScale={2} decimalSeparator={','} fixedDecimalScale={true} displayType={'text'} />{ object[attributes[0]] !== null ? " €" : "" }</span>
            case "vat":
                if (item === "products")
                    return <Link to={ "/products/" + object.id + "/pricelists" }>
                        <span>{ object[attributes[0]] !== null ? object[attributes[0]].replace(".", ",").replace("%", " %") : "" }</span>
                    </Link>
                else
                    return <span>{ object[attributes[0]] !== null ? object[attributes[0]].replace(".", ",").replace("%", " %") : "" }</span>
            case "fromNow":
                return <span>
                    il y a <b>{ displaySince(object[attributes[0]]) }</b><br />
                    par <b>{ object[attributes[1]] }</b>
                </span>
            case "state":
                switch (item) {
                    case "clients":
                        return <p className={"state " + object[attributes[0]]}>{ StoreController._states[object[attributes[0]]] }</p>;
                    case "contracts":
                        return <p className={"state " + object[attributes[0]]} onMouseOver={() => { mouseOverContractState(true, object[attributes[0]]) }} onMouseOut={() => { mouseOverContractState(false) }}>{ ContractController._states[object[attributes[0]]] }</p>;
                    case "developmentRequests":
                        return <p className={"state " + object[attributes[0]]}>{ DevelopmentRequestController._states[object[attributes[0]]] }</p>;
                    default:
                        return <p className={"state " + object[attributes[0]]}>{ object[attributes[0]] }</p>
                }
			case "commitment":
				return <p onMouseOver={() => { mouseOverContractCommitment(true) }} onMouseOut={() => { mouseOverContractCommitment(false) }}>{ object[attributes[0]] }</p>
            case "text":
            default:
                return object[attributes[0]];
        }
    }
	const mouseOverContractCommitment = over => {
		if (!over) {
			setBubbleText(null);
			return;
		}

		let text;

		if (object.end === null) {
			if (moment() > moment(object.begin).add(object.commitment, "months")) {
				text = "Plus d'engagement";
			}
			else {
				let limit = moment(object.begin).add(object.commitment, "months");
				text = "Jusqu'au " + limit.format("dddd Do MMMM YYYY") + ", " + limit.fromNow() + ".";
			}
		}
		else {
			let limit = moment(object.begin).add(object.commitment, "months");
			text = "Jusqu'au " + limit.format("dddd Do MMMM YYYY") + ", " + limit.fromNow() + ".";
		}

		setBubbleText(text);
	}
	const mouseOverContractAmount = over => {
		if (!over || object.discountType === null) {
			setBubbleText(null);
			return;
		}

		let discountValue = null;

		switch (object.discountType) {
			case "DEVISE":
				discountValue = "Remise de " + StringTools.number_format(object.discountValue, 2, ",", " ") + " €";
				break;
			case "PERCENT":
				discountValue = "Remise de " + StringTools.number_format(object.discountValue, 0, ",", " ") + " %, soit -" + StringTools.number_format(object.discountAmount, 2, ",", " ") + "€";
				break;
			case "OFFERED":
				discountValue = "Offert, soit - " + StringTools.number_format(object.discountAmount, 2, ",", " ") + " €";
				break;
			default: break;
		}

		if (object.discountDuration !== null) {
			discountValue += " pendant " + parseInt(object.discountDuration) + " mois";
		}

		setBubbleText(discountValue);
	}
	const mouseOverContractState = (over, value) => {
		if (!over) {
			setBubbleText(null);
			return;
		}

		if (["WAITING","TERMINATING","TERMINATED"].includes(value)) {
			switch (value) {
				case "WAITING":
					let days = moment(object.completionDeadline).diff(moment(), "days");
					setBubbleText(days + " jour" + (days > 1 ? "s" : "") + " restant" + (days > 1 ? "s" : ""));
					break;
				case "TERMINATING":
					setBubbleText("Résiliation prévue le " + moment(object.terminated_on).format("LLLL") + ", par " + object.terminator);
					break;
				case "TERMINATED":
					setBubbleText("Résilié le " + moment(object.terminated_on).format("LLLL") + ", par " + object.terminator);
					break;
				default: break;
			}
		}
	}
	const buildOpenable = () => {
		if (!openable)
			return;

		switch (item) {
			case "contracts":
				return <td className="access3Points">
					<AccessIcon idAttribute={"editContract-" + object.id} classname={"edit"} click={ () => { handleMenu(object) } } />
				</td>;
			default:
				return <td className="access"><Link to={ buildLinkOpenable() }><button><span>Ouvrir</span></button></Link></td>;
		}
	}
    const buildLink = column => {
        if (column.link.includes("http"))
            return <a href={ column.link } target="_blank">{ buildForType(column.attributes, column.type) }</a>
        else {
            let link = "/" + item.toLowerCase() + "/" + column.link;
            const regex = /\{([a-zA-Z]+)\}/g;
            const matches = link.match(regex);
            let param;

            for (let index in matches) {
                param = matches[index].replace('{','').replace('}','');
                link = link.replace(matches[index], object[param]);
            }

            return <Link to={ link }>{ buildForType(column.attributes, column.type) }</Link>;
        }
    }
    const buildLineFromModel = () => {
        return model.map((column, index) => (
            <td key={ index } className={ column.class }>
                {
                    column.link !== undefined
                        ? buildLink(column)
                        : buildForType(column.attributes, column.type)
                }
            </td>
        ));
    }
    const buildLinkOpenable = () => {
        switch (item) {
            case "clients":
                return "/clients/" + object.id + "/informations";
            case "developmentRequests":
                return "/developmentrequests/" + object.id;
            default:
                return "/" + object.id;
        }
    }
	const buildPreview = () => {
		if (!preview)
			return;

		return <td className="preview"><button><ArrowIcon /></button></td>;
	}

    useEffect(() => {
        colorLine()
    }, [checked]);

    return(
        <tr id={ "line-" + object.id }>
            {
                checkable
                && <td className="checkbox"><InputCheckbox name={ "selected-" + object.id } checked={ checked } handleChange={ handleClickOnCheckbox } /></td>
            }
            { buildLineFromModel() }
            { buildOpenable() }
            { buildPreview() }
        </tr>
    )
}

export default Line;